var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 504.1 407.2",
    style: {
      enableBackground: "new 0 0 504.1 407.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M447.8,375.4l-206.7,0v31.5l227.8,0l35.1,0.3L274.2,30.5L255.9,0l-96.6,158.4c-5.5-0.8-11.2-1.2-16.9-1.2H142 c-36.9,0-73.7,0-110.6,0V0H0v157.2c0,0,0,0,0,0c0,10.5,0,21,0,31.5h0v99.8h31.5v0h85.3v0l0,0l57.2-93.8 c32.3,12.7,55.1,44.1,55.1,80.9l0,13c0,48-38.9,87-87,87h0H0v31.5c47.3,0,94.6,0,142,0c0,0,0,0,0,0c65.5,0,118.6-53.1,118.6-118.6 V282v-6.6c0-48.1-28.7-89.5-70-108l65.2-106.8L447.8,375.4z M99.1,257H31.5v-68.3h109.3L99.1,257z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f50909710bdbb40c2bdd27f00dcc39b5.svg";
export { ForwardRef as ReactComponent };